import { Listrak } from '$services/listrak'

export default defineNuxtPlugin(() => {
    const runtimeConfig = useRuntimeConfig()
    const listrakProvider = new Listrak.ListrakPlugin(<Listrak.InitOptions>{
        ...runtimeConfig.public.listrak
    })

    return {
        provide: {
            listrak: listrakProvider
        }
    }
})
